import { useContext } from "react";
import ScrollableContainer from "../../layout/scrollable-container";
import Container from "../../layout/container";
import TransitionWrapper from "../../components/transition-wrapper/TransitionWrapper";
import * as Styled from "./styles";
import Footer from "../../components/footer";
import { TransferContext } from "../../context/TransferContext";
import MeetingScheduledVector from "./assets/meeting-scheduled.png";
import { BodyLargeRegular, HeadlineMedium } from "../../components/font";
import Flex from "../../layout/flex";
import { Button } from "@manifesthhqinc/ui-library";
const SchedulePhoneCallConfirmation = () => {
  const { navigateToHomeScreen } = useContext(TransferContext);
  return (
    <TransitionWrapper>
      <ScrollableContainer name="phone-call-scheduled-screen">
        <Container>
          <Flex $flexGap="8" $flexDirection="column">
            <HeadlineMedium $textAlign="center">Meeting scheduled!</HeadlineMedium>
            <BodyLargeRegular $textAlign="center">
              You’re all set. Just relax and wait for Manifest to give you a call at the scheduled time. We’re working
              on your transfer now.
            </BodyLargeRegular>
          </Flex>

          <Styled.VectorWrapper>
            <img src={MeetingScheduledVector} alt="assign specialist" height={173} />
          </Styled.VectorWrapper>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="schedulePhoneCall" onClick={navigateToHomeScreen} size="large">
          Got it!
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};
export default SchedulePhoneCallConfirmation;
